<template>
  <div class="main">
    <div class="nav">
      <!-- <span>运费费率表</span> -->
      <span>
        <el-button class="addBtn" type="primary" size="mini" @click="addFreight">新增运费费率</el-button>
      </span>
    </div>
    <div class="content">
      <div class="nav">
        <span>序号</span>
        <span>运费名称</span>
        <span>条件</span>
        <span>运费价格</span>
      </div>
      <div class="list">
        <div class="listItem" v-for="(item,index) in 15" :key="index">
          <span>{{ index+1 }}</span>
          <span>Standart Shipping (12-20 days)</span>
          <span>US$0.00 - US$29.99</span>
          <span>US $12.99</span>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pag">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="30"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="20"
        ></el-pagination>
      </div>
    </div>
    <!-- 添加运费费率 -->
    <el-dialog
      title="添加运费费率"
      :visible.sync="dialogFormVisible"
      width="540px"
      :close-on-click-modal="false"
    >
      <div class="inputs">
        <div class="oinput">
          <h4>运费名称:</h4>
          <el-input v-model="value" placeholder="请输入内容" size="small"></el-input>
        </div>
        <div class="oinput">
          <h4>运输价格:</h4>
          <div class="text">
            <span>US$</span>
            <input type="text" placeholder="0.00" />
          </div>
        </div>
        <div class="doubleInput">
          <div class="oinput">
            <h4>订单最低价格:</h4>
            <div class="text">
              <span>US$</span>
              <input type="text" placeholder="0.00" />
            </div>
          </div>
            <span style="margin-top:30px;margin-right:20px;">--</span>
          <div class="oinput">
            <h4>订单最高价格:</h4>
            <div class="text">
              <span>US$</span>
              <input type="text" placeholder="无限制" />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false" size="small">确 定</el-button>
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogFormVisible: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  methods: {
    addFreight() {
      this.dialogFormVisible = true;
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.main {
  background-color: #fff;
  border: 1px solid rgba(235, 237, 248, 1);
  > .nav {
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 50px;
    // border-bottom: 1px solid rgba(235, 237, 248, 1);
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    .addBtn {
      margin-right: 20px;
    }
  }
  > .content {
    padding: 20px;
    > .nav {
      margin-bottom: 10px;
      padding: 0 20px;
      span {
        height: 14px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
      }
      span:nth-child(1) {
        width: 6%;
        display: inline-block;
        text-align: center;
      }
      span:nth-child(2) {
        width: 34%;
        display: inline-block;
        text-align: center;
      }
      span:nth-child(3) {
        width: 40%;
        display: inline-block;
        text-align: center;
      }
      span:nth-child(4) {
        width: 10%;
        display: inline-block;
        text-align: center;
      }
    }
    > .list {
      > .listItem {
        padding: 0 20px;
        margin-bottom: 5px;
        height: 40px;
        line-height: 40px;
        background: rgba(246, 249, 252, 1);
        border-radius: 2px;
        &:hover {
          background-color: #eee;
        }
        span:nth-child(1) {
          width: 6%;
          display: inline-block;
          text-align: center;
        }
        span:nth-child(2) {
          width: 34%;
          display: inline-block;
          text-align: center;
        }
        span:nth-child(3) {
          width: 40%;
          display: inline-block;
          text-align: center;
        }
        span:nth-child(4) {
          width: 10%;
          display: inline-block;
          text-align: center;
        }
      }
    }
  }
}
// 分页
.pag {
  text-align: center;
  margin-top: 20px;
}
.inputs {
  > .oinput {
    margin-right: 20px;
    margin-bottom: 10px;
    > h4 {
      width: 100px;
      padding-right: 12px;
      line-height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
    }
    > .el-select {
      width: 100%;
    }
    > .text {
      width: 100%;
      height: 30px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(216, 216, 216, 1);
      padding: 0 10px;
      display: flex;
      align-items: center;
      > span:first-child {
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(85, 85, 85, 1);
        line-height: 14px;
      }
      > span:nth-child(2) {
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 14px;
        margin-left: 10px;
      }
      > p {
        width: 55px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background: rgba(228, 228, 228, 1);
        border-radius: 13px;
        margin-left: auto;
        font-size: 12px;
      }
      > input {
        margin-left: 10px;
      }
    }
  }
  > .doubleInput {
    display: flex;
    >.oinput:first-child{
      // margin-left: 96px;
    }
    > .oinput {
      margin-right: 20px;
      // display: flex;
      // align-items: center;
      margin-bottom: 10px;
      > h4 {
        width: 100px;
        padding-right: 12px;
        line-height: 24px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
      }
      > .el-select {
        width: 100%;
      }
      > .text {
        width: 100%;
        height: 30px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(216, 216, 216, 1);
        padding: 0 10px;
        display: flex;
        align-items: center;
        > span:first-child {
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(85, 85, 85, 1);
          line-height: 14px;
        }
        > span:nth-child(2) {
          height: 14px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 14px;
          margin-left: 10px;
        }
        > p {
          width: 55px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          background: rgba(228, 228, 228, 1);
          border-radius: 13px;
          margin-left: auto;
          font-size: 12px;
        }
        > input {
          margin-left: 10px;
        }
      }
    }
  }
}
/deep/ .dialog-footer {
  text-align: center;
}
/deep/ .el-dialog__body {
  padding-bottom: 10px;
  padding-top: 10px;
}
</style>